export default __webpack_public_path__ + "static/media/firebase-logo.0ac5b985.svg";